import { createStore } from "vuex"
import user from './module/user'
import product from './module/product'
const store = createStore({
    state(){
        return{
            count:0
        }
    },
    mutations:{
        
    },
    getters:{},
    actions:{
        
    },
    modules:{
        user,
        product
    },
})
export default store